<template>
  <section class="px-5">
    <div class="grid grid-cols-12 mb-5 border-b pb-5">
      <p class="col-span-6 text-13px text-fg-muted font-normal">Currency:</p>
      <div
        class="col-span-5 text-13px font-normal text-black flex items-center gap-x-2"
      >
        <currency-icons :currency="getCurrencyCountry(selectedCurrency)" />
        <p>{{ selectedCurrency }}</p>
      </div>
    </div>
    <div>
      <!-- BE is returning a different structure for GHS and XAF, thats why we have this section -->
      <div class="grid grid-cols-12 mb-5 border-b pb-5">
        <p class="col-span-6 text-13px text-fg-muted font-normal">
          Account Name:
        </p>
        <div
          class="col-span-5 text-13px font-normal text-black flex items-center gap-x-2"
        >
          <p>
            {{
              selectedAccountDetails.transferInstructions.accountName || '--'
            }}
          </p>
        </div>
      </div>
      <div class="grid grid-cols-12 mb-5 border-b pb-5">
        <p class="col-span-6 text-13px text-fg-muted font-normal">
          Account Number:
        </p>
        <div
          class="col-span-5 text-13px font-normal text-black flex items-center gap-x-2"
        >
          <p>
            {{
              selectedAccountDetails.transferInstructions.accountNumber || '--'
            }}
          </p>
        </div>
        <div
          class="col-span-1 cursor-pointer"
          v-clipboard:copy="
            selectedAccountDetails.transferInstructions.accountNumber
          "
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
        >
          <copy-icon />
        </div>
      </div>
      <div class="grid grid-cols-12 mb-5 border-b pb-5">
        <p class="col-span-6 text-13px text-fg-muted font-normal">Bank Name:</p>
        <div
          class="col-span-5 text-13px font-normal text-black flex items-center gap-x-2"
        >
          <p>
            {{ selectedAccountDetails.transferInstructions.bankName || '--' }}
          </p>
        </div>
      </div>
      <div class="grid grid-cols-12 mb-5 border-b pb-5">
        <p class="col-span-6 text-13px text-fg-muted font-normal">
          Bank Address:
        </p>
        <div
          class="col-span-5 text-13px font-normal text-black flex items-center gap-x-2"
        >
          <p>
            {{
              selectedAccountDetails.transferInstructions.bankAddress || '--'
            }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
// Todo: refactor implementation to not use repeated functions and logic in the deposit account cards
import breakpoints from '@/utils/breakpoints.js'
import { ASSETS, FIAT, NON_NGN_LOCAL_CURRENCIES } from '@/utils/constants'
import { GetCurrencyCountry } from '@/utils/helpers.js'
export default {
  name: 'Drawer',
  data () {
    return {
      breakpoints,
      assets: ASSETS,
      fiat: FIAT,
      nonNGNLocalCurrencies: NON_NGN_LOCAL_CURRENCIES,
      activeAssetNetwork: { value: '' }
    }
  },
  components: {
    CurrencyIcons: () => import('@/assets/icons/CurrencyIcons.vue'),
    CopyIcon: () => import('@/assets/icons/CopyIcon.vue')
  },
  methods: {
    onError: function (e) {
      this.$notify.error('Error copying to clipboard!')
    },
    getCurrencyCountry (val) {
      return GetCurrencyCountry(val)
    },
    onCopy: function (e) {
      this.$notify.success({
        title: 'Copied'
      })
    }
  },
  computed: {
    accountName () {
      return (
        // BCB don't have account name
        this.bankName === 'BCB Group'
          ? this.business.name
          : this.selectedAccountDetails?.transferInstructions?.account_name ||
              this.selectedAccountDetails?.transferInstructions?.wireInstruction
                ?.creditTo ||
              this.selectedAccountDetails?.transferInstructions?.accountName ||
              '--'
      )
    },
    IBAN () {
      return (
        this.selectedAccountDetails?.transferInstructions?.iban ||
        this.selectedAccountDetails?.transferInstructions?.wireInstruction
          ?.iban ||
        this.selectedAccountDetails?.transferInstructions?.iban ||
        '--'
      )
    },
    sortCode () {
      return (
        this.selectedAccountDetails?.transferInstructions?.sort_code ||
        this.selectedAccountDetails?.transferInstructions?.wireInstruction
          ?.sortCode ||
        this.selectedAccountDetails?.transferInstructions?.sortCode ||
        '--'
      )
    },
    accountNumber () {
      return (
        this.selectedAccountDetails?.transferInstructions?.account_number ||
        this.selectedAccountDetails?.transferInstructions?.wireInstruction
          ?.accountNumber ||
        this.selectedAccountDetails?.transferInstructions?.accountNumber ||
        '--'
      )
    },
    bankName () {
      return (
        this.selectedAccountDetails?.transferInstructions?.bank_name ||
        this.selectedAccountDetails?.transferInstructions?.wireInstruction
          ?.depositoryBankName ||
        this.selectedAccountDetails?.transferInstructions?.bankName ||
        '--'
      )
    },
    routingNumber () {
      return (
        this.selectedAccountDetails?.transferInstructions?.rounting_number ||
        this.selectedAccountDetails?.transferInstructions?.wireInstruction
          ?.routingNumber ||
        this.selectedAccountDetails?.transferInstructions?.routingNumber ||
        '--'
      )
    },
    swiftCode () {
      return (
        this.selectedAccountDetails?.transferInstructions?.swift_code ||
        this.selectedAccountDetails?.transferInstructions?.wireInstruction
          ?.swiftCode ||
        this.selectedAccountDetails?.transferInstructions?.swiftCode ||
        '--'
      )
    },
    reference () {
      return (
        this.selectedAccountDetails?.transferInstructions?.reference ||
        this.selectedAccountDetails?.transferInstructions?.wireInstruction
          ?.reference ||
        this.selectedAccountDetails?.transferInstructions?.reference ||
        '--'
      )
    },
    selectedCurrency () {
      return this.$store.state.report.accountDetailsCurrency
    },
    currentAccountDetails () {
      return this.$store.state.transactions.currentAccountInfo.items || []
    },
    selectedAccountDetails () {
      const item = this.currentAccountDetails.find(
        (item) =>
          item.currency === this.selectedCurrency ||
          item.asset === this.selectedCurrency
      )
      return Object.keys(item).length > 0
        ? item
        : { walletAddress: '', network: '' }
    },
    business () {
      return this.$store.state.auth.business
    }
  }
}
</script>
<style scoped></style>
